// extracted by mini-css-extract-plugin
export var root = "Galeria-module--root--17-v-";
export var header = "Galeria-module--header--TuG10";
export var image = "Galeria-module--image--3SVoM";
export var description = "Galeria-module--description--2qEqq";
export var gallery = "Galeria-module--gallery--35DCa";